import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext, useSiteSelection } from "@context";
import { usePreventData, useManagerData } from "@hooks";
import { DashBanner, PreventGrid } from "@components";
import { ROLES } from "@constants/roles";
import DashBreadcrumb from "./DashBreadcrumb";
import "./dash.css";

const Prevent = () => {
    const { auth } = useContext(AuthContext);
    const { compCode, siteCode } = useSiteSelection();
    const isAdminOrR1 = auth?.role === ROLES.SUPER_ADMIN || auth?.roleId === 'R1';

    const params = compCode ? { compCode: compCode } : {};
    const { data, refetch } = usePreventData(params);
    const { data: managerData } = useManagerData(compCode ? { compCode: compCode } : {});

    if (!compCode) {
        return <Navigate to={isAdminOrR1 ? "/dash/company" : "/dash/site"} replace />;
    }
    if (!siteCode) {
        return <Navigate to="/dash/site" replace />;
    }

    return (
        <>
            <DashBreadcrumb />

            <div className="contents-wrap">
                <DashBanner
                    title="예방대책 이행 현황"
                    description="각 현장별로 수립된 중대재해 예방 계획을 확인하고, 실제 현장에서의 조치 내역과 개선 상태를 체계적으로 점검합니다."
                />
                <div style={{ fontSize: "12px", color: "#888", margin: "8px 0 4px", textAlign: "right" }}>
                    첨부 가능 파일: gif · jpg · png · pdf · xls · xlsx · ppt · pptx · docx · doc · hwp · hwpx · txt
                </div>
                {data && (
                    <PreventGrid
                        siteCodes={data.siteDTO}
                        data={data.gridData}
                        refetch={refetch}
                        selectedSite={siteCode}
                    />
                )}
            </div>
            {managerData?.managerName && (
                <div className="dash-manager-info">
                    <span>담당자&nbsp;&nbsp;<strong>{managerData.managerName}</strong></span>
                    <span>연락처&nbsp;&nbsp;<strong>{managerData.managerPhone}</strong></span>
                </div>
            )}
        </>
    );
};

export { Prevent };
